import type { InputHTMLAttributes, ReactElement, Ref } from 'react';
import { cn } from '../lib/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  readonly ref?: Ref<HTMLInputElement>;
  /** true 면 오류 스타일과 aria-invalid 를 적용한다. */
  readonly hasError?: boolean;
}

export const Input = ({ className, hasError = false, ...props }: InputProps): ReactElement => (
  <input
    className={cn(
      'flex h-9 w-full rounded-full border border-input bg-background px-4 py-1 text-sm transition-colors',
      'placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
      'disabled:cursor-not-allowed disabled:opacity-50',
      hasError && 'border-destructive focus-visible:ring-destructive',
      className,
    )}
    aria-invalid={hasError || undefined}
    {...props}
  />
);
